import React, { useContext, Fragment } from 'react';
import { traverseNodes } from './ContentViewer/rericos/render.js';
import { ContentTraverserContext } from 'ricos-context';

var viewerStyles = {"fontElementMap":"_7ejKN","wrapper":"U4I07","pluginContainerMobile":"YfIkb","viewer":"hl-xW","android":"HAWUS","rootedTraversedContent":"k5bj-","atomic":"dsGs-","toolbar":"aCIl4","block":"Sv2V2"};

const RicosNodesRenderer = ({
  nodes,
  isRoot,
  shouldParagraphApplyTextStyle,
  addAnchorsPrefix
}) => {
  const { renderers, nodeViewDecorators } = useContext(ContentTraverserContext);
  const devFallback = void 0;
  const Content = traverseNodes(
    nodes,
    renderers,
    nodeViewDecorators,
    RicosNodesRenderer,
    isRoot,
    shouldParagraphApplyTextStyle,
    addAnchorsPrefix,
    devFallback
  );
  return isRoot ? /* @__PURE__ */ React.createElement("div", { key: "RootedTraversedContent", className: viewerStyles.rootedTraversedContent }, Content) : /* @__PURE__ */ React.createElement(Fragment, { key: "TraversedContent" }, Content);
};

export { RicosNodesRenderer as R, viewerStyles as v };
//# sourceMappingURL=RicosNodesRenderer-7e317cdc.js.map
